export default __webpack_public_path__ + "static/media/welcome_bg.77febaa6.png";